/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Ledger_Source_BcpInputs */



/**
* | output |
* | --- |
* | "BCP (printer)" |
*
* @param {Promo_Ledger_Source_BcpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_ledger_source_bcp = /** @type {((inputs?: Promo_Ledger_Source_BcpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Ledger_Source_BcpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("BCP (imprimeur)")
	if (locale === "es") return /** @type {LocalizedString} */ ("BCP (imprenta)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("BCP (gráfica)")
	if (locale === "it") return /** @type {LocalizedString} */ ("BCP (tipografia)")
	return /** @type {LocalizedString} */ ("BCP (printer)")
});